import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppButton from "@/components/feature/WhatsAppButton";
import PageSEO from "@/components/feature/PageSEO";

const services = [
  {
    id: "vaciado-pisos",
    icon: "ri-home-4-line",
    title: "Vaciado de pisos y casas",
    badge: "Más solicitado",
    desc: "El vaciado de pisos y casas en Girona es nuestro servicio estrella. Retiramos absolutamente todo lo que hay en la vivienda: muebles, electrodomésticos, ropa, libros, objetos personales y cualquier tipo de enseres. Dejamos el piso completamente vacío y barrido, listo para la siguiente etapa.",
    details: [
      "Vaciado completo de pisos, áticos, bajos y casas unifamiliares",
      "Retirada de muebles de todo tipo: armarios, sofás, camas, mesas",
      "Recogida de electrodomésticos: neveras, lavadoras, hornos",
      "Gestión de objetos personales con total discreción",
      "Limpieza básica post-vaciado incluida",
      "Gestión responsable de residuos en puntos autorizados",
    ],
    situations: [
      "Herencias y liquidación de bienes",
      "Cambio de inquilino o fin de contrato",
      "Preparación para venta o reforma",
      "Mudanzas con mucho volumen",
    ],
    img: "https://public.readdy.ai/ai/img_res/a17bad07d13e9b91bb1d74c0100f954a.jpg",
    imgAlt: "Vaciado de pisos y casas en Girona - GIROBUIT",
  },
  {
    id: "vaciado-locales",
    icon: "ri-store-2-line",
    title: "Vaciado de locales comerciales",
    badge: "Empresas",
    desc: "Vaciamos locales comerciales, oficinas, naves industriales y cualquier tipo de espacio de negocio en Girona y comarca. Sabemos que el tiempo es dinero, por eso trabajamos con rapidez y eficiencia para que puedas retomar tu actividad o entregar el local cuanto antes.",
    details: [
      "Vaciado de tiendas, restaurantes, bares y locales de todo tipo",
      "Retirada de mobiliario comercial, estanterías y equipamiento",
      "Vaciado de oficinas: mesas, sillas, archivadores, equipos",
      "Naves industriales y almacenes",
      "Servicio urgente disponible para entregas de local",
      "Coordinación con propietarios y administradores",
    ],
    situations: [
      "Cierre de negocio o traspaso",
      "Fin de contrato de arrendamiento",
      "Reforma o cambio de actividad",
      "Liquidación de empresa",
    ],
    img: "https://readdy.ai/api/search-image?query=professional%20team%20clearing%20out%20a%20commercial%20space%20in%20Spain%2C%20removing%20shelves%20and%20office%20furniture%2C%20bright%20commercial%20interior%2C%20photorealistic%2C%20high%20quality%2C%20organized%20workers%2C%20Spanish%20business%20clearance&width=700&height=500&seq=serv002&orientation=landscape",
    imgAlt: "Vaciado de locales comerciales en Girona - GIROBUIT",
  },
  {
    id: "retirada-muebles",
    icon: "ri-truck-line",
    title: "Retirada de muebles y electrodomésticos",
    badge: "Servicio mínimo: 1 furgoneta",
    desc: "Recogemos y retiramos muebles y electrodomésticos en Girona y comarca. Importante: no ofrecemos recogida de piezas sueltas. El servicio mínimo es una furgoneta completa. Si tienes varios muebles o electrodomésticos que retirar, este es tu servicio.",
    details: [
      "Retirada de muebles de todo tipo y tamaño",
      "Recogida de electrodomésticos: neveras, lavadoras, lavavajillas",
      "Servicio mínimo: una furgoneta completa",
      "No se recogen piezas sueltas",
      "Gestión de residuos en puntos autorizados",
      "Posibilidad de donación de lo que esté en buen estado",
    ],
    situations: [
      "Renovación de mobiliario del hogar",
      "Vaciado parcial de habitaciones",
      "Preparación de piso para alquiler",
      "Retirada de electrodomésticos averiados",
    ],
    img: "https://readdy.ai/api/search-image?query=workers%20loading%20furniture%20and%20appliances%20into%20a%20moving%20van%20in%20Spain%2C%20sunny%20street%2C%20professional%20clearance%20service%2C%20photorealistic%2C%20high%20quality%2C%20warm%20tones%2C%20urban%20setting&width=700&height=500&seq=serv003&orientation=landscape",
    imgAlt: "Retirada de muebles y electrodomésticos en Girona - GIROBUIT",
  },
  {
    id: "limpieza-diogenes",
    icon: "ri-heart-pulse-line",
    title: "Limpieza por síndrome de Diógenes",
    badge: "Servicio especializado",
    desc: "La limpieza por síndrome de Diógenes requiere un equipo especializado, con experiencia y, sobre todo, con sensibilidad humana. En GIROBUIT actuamos con total discreción y respeto hacia las personas afectadas y sus familias. Realizamos la limpieza extrema, desinfección y vaciado completo de la vivienda.",
    details: [
      "Limpieza extrema de viviendas con acumulación severa",
      "Desinfección y eliminación de olores",
      "Retirada de residuos orgánicos e inorgánicos",
      "Actuación discreta: coordinamos accesos para minimizar visibilidad",
      "Equipo con formación específica y equipos de protección",
      "Colaboración con servicios sociales y familiares",
    ],
    situations: [
      "Síndrome de Diógenes diagnosticado",
      "Acumulación severa de objetos y residuos",
      "Situaciones post-fallecimiento con abandono",
      "Casos derivados por servicios sociales",
    ],
    img: "https://readdy.ai/api/search-image?query=professional%20cleaning%20team%20in%20protective%20gear%20cleaning%20a%20heavily%20cluttered%20apartment%20in%20Spain%2C%20organized%20and%20systematic%20approach%2C%20photorealistic%2C%20high%20quality%2C%20professional%20service%2C%20respectful%20and%20discreet&width=700&height=500&seq=serv004&orientation=landscape",
    imgAlt: "Limpieza por síndrome de Diógenes en Girona - servicio discreto GIROBUIT",
  },
  {
    id: "pintura",
    icon: "ri-paint-brush-line",
    title: "Pintura final",
    badge: "Valor añadido",
    desc: "Una vez vaciado el piso o local, ofrecemos el servicio de pintura interior para dejarlo listo para la venta o el alquiler. Una buena pintura puede aumentar significativamente el valor percibido del inmueble y acelerar su comercialización. Trabajamos con acabados profesionales y colores neutros que gustan a todos los compradores.",
    details: [
      "Pintura interior de pisos, casas y locales",
      "Preparación de superficies: masillado y lijado",
      "Colores neutros recomendados para venta o alquiler",
      "Acabados profesionales con rodillo y brocha",
      "Protección de suelos y elementos fijos",
      "Limpieza final incluida",
    ],
    situations: [
      "Preparación de piso para venta",
      "Renovación para nuevo inquilino",
      "Actualización de local comercial",
      "Post-vaciado de herencia",
    ],
    img: "https://readdy.ai/api/search-image?query=professional%20painter%20painting%20white%20walls%20in%20a%20Spanish%20apartment%2C%20clean%20and%20bright%20interior%2C%20roller%20and%20paint%2C%20photorealistic%2C%20high%20quality%2C%20warm%20natural%20light%2C%20renovation%20service&width=700&height=500&seq=serv005&orientation=landscape",
    imgAlt: "Pintura interior de pisos y locales en Girona - GIROBUIT",
  },
];

function FadeIn({ children, className = "" }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${className}`}
    >
      {children}
    </div>
  );
}

export default function ServiciosPage() {
  const [activeTab, setActiveTab] = useState("vaciado-pisos");
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  return (
    <div style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <PageSEO
        title="Servicios de Vaciado de Pisos y Locales en Girona | GIROBUIT"
        description="Vaciado de pisos y casas, locales comerciales, limpieza por síndrome de Diógenes, retirada de muebles y pintura final en Girona. Presupuesto sin compromiso."
        canonical="https://girobuit.com/servicios"
        pageType="CollectionPage"
        breadcrumbs={[
          { name: "Inicio", url: "https://girobuit.com/" },
          { name: "Servicios", url: "https://girobuit.com/servicios" },
        ]}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative h-[45vh] min-h-[380px] flex items-center justify-center overflow-hidden pt-20">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20clearance%20and%20renovation%20services%20in%20Spain%2C%20multiple%20workers%20in%20different%20tasks%2C%20bright%20modern%20apartment%2C%20photorealistic%2C%20high%20quality%2C%20warm%20tones%2C%20service%20company%20team&width=1920&height=600&seq=servhero001&orientation=landscape"
          alt="Servicios de vaciado de pisos y locales en Girona - GIROBUIT"
          className="absolute inset-0 w-full h-full object-cover object-top"
          width={1920}
          height={600}
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-[#330000]/75"></div>
        <div className="relative z-10 text-center px-4 pt-4">
          <nav className="text-xs text-red-300 mb-4">
            <Link to="/" className="hover:text-white cursor-pointer">Inicio</Link>
            <span className="mx-2">/</span>
            <span className="text-white">Servicios</span>
          </nav>
          <h1 className="text-4xl md:text-5xl font-900 text-white" style={{ fontWeight: 900 }}>
            Nuestros servicios en Girona
          </h1>
          <p className="text-red-200 mt-3 text-lg max-w-2xl mx-auto">
            Vaciado de pisos, limpieza extrema y pintura. Todo lo que necesitas en un solo servicio.
          </p>
        </div>
      </section>

      {/* Sticky Tabs */}
      <div className="sticky top-20 z-30 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex gap-1 overflow-x-auto py-3 scrollbar-hide">
            {services.map((s) => (
              <button
                key={s.id}
                onClick={() => {
                  setActiveTab(s.id);
                  document.getElementById(s.id)?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-xs font-600 whitespace-nowrap cursor-pointer transition-all duration-200 flex-shrink-0 ${
                  activeTab === s.id
                    ? "bg-[#ff0000] text-white"
                    : "text-[#330000] hover:bg-[#ff0000]/10"
                }`}
                style={{ fontWeight: 600 }}
              >
                <i className={`${s.icon} text-sm`}></i>
                {s.title.split(" ").slice(0, 2).join(" ")}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Services Detail */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        {services.map((service, i) => (
          <section
            key={service.id}
            id={service.id}
            className={`py-16 md:py-20 ${i < services.length - 1 ? "border-b border-gray-100" : ""}`}
          >
            <FadeIn>
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${i % 2 !== 0 ? "lg:flex-row-reverse" : ""}`}
                style={{ direction: i % 2 !== 0 ? "rtl" : "ltr" }}
              >
                <div style={{ direction: "ltr" }}>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="inline-flex items-center gap-1.5 text-xs font-700 text-[#ff0000] bg-[#ff0000]/10 px-3 py-1 rounded-full" style={{ fontWeight: 700 }}>
                      <i className={`${service.icon} text-sm`}></i>
                      {service.badge}
                    </span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-800 text-[#330000] mb-4" style={{ fontWeight: 800 }}>
                    {service.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed mb-6 text-base">{service.desc}</p>

                  {/* Includes */}
                  <div className="mb-6">
                    <h3 className="text-sm font-700 text-[#330000] mb-3" style={{ fontWeight: 700 }}>¿Qué incluye?</h3>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      {service.details.map((d) => (
                        <li key={d} className="flex items-start gap-2 text-sm text-gray-600">
                          <i className="ri-check-line text-[#ff0000] mt-0.5 flex-shrink-0"></i>
                          {d}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Accordion: Situations */}
                  <div className="mb-6">
                    <button
                      onClick={() => setOpenAccordion(openAccordion === service.id ? null : service.id)}
                      className="flex items-center justify-between w-full text-left py-3 border-t border-b border-gray-100 cursor-pointer"
                      aria-expanded={openAccordion === service.id}
                    >
                      <h3 className="text-sm font-700 text-[#330000] m-0" style={{ fontWeight: 700 }}>Situaciones habituales</h3>
                      <i className={`ri-add-line text-[#ff0000] text-lg transition-transform duration-200 ${openAccordion === service.id ? "rotate-45" : ""}`}></i>
                    </button>
                    {openAccordion === service.id && (
                      <ul className="pt-3 pb-2 flex flex-col gap-1.5">
                        {service.situations.map((s) => (
                          <li key={s} className="flex items-center gap-2 text-sm text-gray-600">
                            <i className="ri-arrow-right-s-line text-[#ff0000]"></i>
                            {s}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3 w-full">
                    <a
                      href="tel:+34602365996"
                      className="flex items-center justify-center gap-2 bg-[#ff0000] text-white px-6 py-3.5 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#cc0000] hover:scale-105 w-full sm:w-auto"
                      style={{ fontWeight: 700 }}
                    >
                      <i className="ri-phone-fill"></i> Pedir presupuesto
                    </a>
                    <a
                      href="https://wa.me/34602365996"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-center gap-2 border-2 border-[#330000] text-[#330000] px-6 py-3.5 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#330000] hover:text-white w-full sm:w-auto"
                      style={{ fontWeight: 700 }}
                    >
                      <i className="ri-whatsapp-line text-[#25D366]"></i> WhatsApp
                    </a>
                  </div>
                </div>

                <div style={{ direction: "ltr" }}>
                  <img
                    src={service.img}
                    alt={service.imgAlt}
                    className="w-full h-[380px] object-cover object-top rounded-2xl"
                    width={700}
                    height={500}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </div>
            </FadeIn>
          </section>
        ))}
      </div>

      {/* Bottom CTA */}
      <section className="py-16 bg-[#FF6666]">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-800 text-[#330000] mb-4" style={{ fontWeight: 800 }}>
            ¿No sabes qué servicio necesitas?
          </h2>
          <p className="text-[#330000]/80 mb-8">
            Cuéntanos tu situación y te asesoramos sin compromiso. Atendemos en Girona, Salt, Banyoles y toda la comarca.{" "}
            <Link to="/empresa" className="underline font-700 text-[#330000] hover:text-[#ff0000] transition-colors cursor-pointer" style={{ fontWeight: 700 }}>
              Conoce quiénes somos
            </Link>{" "}
            y cómo trabajamos.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+34602365996"
              className="flex items-center justify-center gap-2 bg-[#330000] text-white px-8 py-4 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#ff0000]"
              style={{ fontWeight: 700 }}
            >
              <i className="ri-phone-fill"></i> Llamar: 602 36 59 96
            </a>
            <Link
              to="/faq"
              className="flex items-center justify-center gap-2 border-2 border-[#330000] text-[#330000] px-8 py-4 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#330000] hover:text-white"
              style={{ fontWeight: 700 }}
            >
              <i className="ri-question-line"></i> Ver preguntas frecuentes
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
